<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title'])
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    //退出登陆
    logout(){
      this.$dialog.confirm({
        message: '确定要退出登陆吗？',
      }).then(res=>{
        this.$store.commit('logout');
        this.$toast('退出登陆成功');
        this.$router.back();
      }).catch(err=>{});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/shezhi/index.vue